import { Box, Tooltip, Typography } from "@mui/material";
import { GiWaves } from "react-icons/gi";

import { displayListOfMonths } from "../../../common/utils/utils";

const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function getSurfSeasonLabel(surfSeason) {
  if (!surfSeason || surfSeason.length === 0) return "";
  if (surfSeason.includes("All year round")) return "Year-round";

  const months = surfSeason.map(Number).sort((a, b) => a - b);
  if (months.length === 1) return MONTH_NAMES[months[0] - 1];

  const monthSet = new Set(months);
  let longestStart = months[0];
  let longestLength = 0;

  for (const month of months) {
    const prev = month === 1 ? 12 : month - 1;
    if (monthSet.has(prev)) continue;

    let length = 0;
    let current = month;
    while (monthSet.has(current)) {
      length++;
      current = current === 12 ? 1 : current + 1;
    }

    if (length > longestLength) {
      longestLength = length;
      longestStart = month;
    }
  }

  const endMonth = ((longestStart - 1 + longestLength - 1) % 12) + 1;
  return `${MONTH_NAMES[longestStart - 1]} → ${MONTH_NAMES[endMonth - 1]}`;
}

const SurfSeasonBadge = ({ surfSeason }) => {
  return (
    <Tooltip title={`Best surf season: ${displayListOfMonths(surfSeason)}.`}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          borderRadius: 1.5,
          px: 1.5,
          py: 1,
          bgcolor: "secondary.main",
          m: 0.5,
        }}
      >
        <GiWaves size={18} color="#05668D" />
        <Typography
          variant="body2"
          fontWeight="bold"
          sx={{ color: "#05668D", letterSpacing: 0.5, whiteSpace: "nowrap" }}
        >
          {getSurfSeasonLabel(surfSeason)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default SurfSeasonBadge;
